<template>
    <b-card header-tag="header" footer-tag="footer" class="mt-8">
        <template v-slot:header>
            <div class="d-flex">
                <div class="mr-auto py-2 d-flex">
                    <b-button variant="info" class="button-block-mobile px-5" @click.prevent="$emit('open-add-modal')"> + Agregar</b-button>
                </div>
            </div>
        </template>
        <b-card-text>
            <b-table 
                responsive
                :fields="fields" 
                striped hover outlined fixed
                :items="imageList">
                <template v-slot:cell(file_url)="data">
                    <div class="image-list">
                        <b-img :src="data.item.file_url"></b-img>
                    </div>
                </template>
                <template v-slot:cell(category)="data">
                    {{ translateSection(data.item.category) }}
                </template>
                <template v-slot:cell(order)="data">
                    {{ data.item.order }}
                </template>
                <template v-slot:cell(actions)="{ item }">
                    <b-button variant="danger" size="sm" v-b-tooltip.hover title="Eliminar"
                        @click.prevent="deleteImageModal(item)">
                        <b-icon icon="trash"></b-icon>
                    </b-button>
                </template>
            </b-table>
            <template v-if="imageList.length < 1">
                <b-alert show variant="danger">
                    No ha cargado imagenes todavia.
                </b-alert>
            </template>
        </b-card-text>
    </b-card>
</template>

<script>
import { configTranslations } from '@/translations/config/image.js';
import { mapMutations } from 'vuex'
export default {
    name: "ImageListTable",
    props: {
        imageList: {
            type: Array
        }
    },
    data(){
        return{
            fields: [
                { key: 'file_url', label: 'Imagen', sortable: true},
                { key: 'category', label: 'Sección', sortable: true},
                { key: 'order', label: 'Orden', sortable: true},
                { key: 'actions', label: 'Acciones'},
            ]
        }
    },
    methods:{
        ...mapMutations(['setLoading']),
        deleteImageModal(imageData){
            this.$swal({
                title: "¿Desea eliminar la imagen??",
                text: "Una vez eliminada, ya no se mostrara en el sistema web",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: '#008F39',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Si, eliminar imagen.',
                cancelButtonText: 'Cancelar'
                })
                .then((result) => {
                if (result.isConfirmed) {
                    this.deleteImage(imageData);
                }
            });
        },
        async deleteImage(imageData){
            this.setLoading(true)
            await this.$conectar.post('configuration/client-web/delete-image-data', imageData)
            .then(response =>{
                if(response.data.error === false){
                    this.$emit('update-image-list');
                }
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
        },
        translateSection(constant) {
            const translation = configTranslations[constant];
            if (translation) {
                return translation;
            } else {
                return constant;
            }
        }
    }
};

</script>
<style scoped>

.image-list img{
    max-width: 100%; 
    max-height: 150px; 
    object-fit: scale-down;
}

</style>